export default "__VITE_ASSET__BPKi_aDx__"